// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const AlignMiddleIcon = props => <Icon {...props} dangerouslySetIcon={'<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M6 9a3 3 0 013-3h6a3 3 0 013 3v2h5a1 1 0 110 2h-5v2a3 3 0 01-3 3H9a3 3 0 01-3-3v-2H1a1 1 0 110-2h5V9zm3-1a1 1 0 00-1 1v6a1 1 0 001 1h6a1 1 0 001-1V9a1 1 0 00-1-1H9z"/></svg>'} />;

AlignMiddleIcon.displayName = 'AlignMiddleIcon';

export default AlignMiddleIcon;
